import startCase from 'lodash/startCase';
import {
	PROJECT_TYPES,
	type ProjectType as ProjectTypeKey,
} from '@atlassian/jira-common-constants/src/project-types';
import type { ProjectType } from '@atlassian/jira-common-directory-v2/src/model';

export const getProjectTypes = (): ProjectType[] =>
	PROJECT_TYPES.map((projectKey: ProjectTypeKey) => ({
		id: projectKey,
		name: startCase(projectKey),
		icon: undefined,
	}));
